import React, {Component} from 'react';
import './login.css';
import firebase from 'firebase';

const auth=firebase.auth();	

class Login extends Component{
	
	
	
	constructor(){
		
		
		super();
		this.state={
			
			
		}
		
		this.handleSubmit=this.handleSubmit.bind(this);
		

	}
	
	
	componentDidMount(){

		this.activar();
		
		firebase.auth().onAuthStateChanged(firebaseUser =>{
			
			if(firebaseUser){
				
				console.log(firebaseUser);
				
			}
			else{
				
				console.log('not logged in');
				
			}
			
			
		});
		
		
		
	}

	activar = () =>{

		firebase.database().ref('Empleados').once('value').then(snap =>{
			snap.forEach(element => {
				firebase.database().ref().child('Empleados/'+element.key).update({
					ViajeActualE:'ninguno',
					viajeEmpresa:'Disponible'
				})
			});
		})
	}
	
	handleSubmit(event){
		
		//Credenciales
		let user=this.email.value;
		let pass=this.pass.value;
		
		
		let promise=auth.signInWithEmailAndPassword(user,pass);
		
		promise
		.then(user => console.log(user))
		.catch(e => console.log(e.message));
		
		event.preventDefault();
	}
	
	
	
	
	
	
	render(){
		
		return(
			
			
			<div className="login">
				<div className="box">
					
				
						<h2>Acacya</h2>
						<form onSubmit={this.activar}>
							<div className="inputBox">
								<input type="email" name="" required
								ref={input => {this.email=input;}}
								/>
								<label>Usuario</label>
							</div>
							<div className="inputBox" >
								<input type="password" name="" className="password" required
								ref={input => {this.pass=input;}}
								/>
								<label>Contraseña</label>
							</div>
							<input type="submit" name="" value="Ingresar"/>
						</form>
					
				
				
				</div>
			</div>
		
		
		);	
	}
}

export default Login;


// WEBPACK FOOTER //
// ./src/Components/Login/Login.jsx